import React from 'react'
import {Route, IndexRedirect} from 'react-router'

import OrdersOverviewView from 'views/OrdersOverviewView'
import OrdersOverviewViewMenu from 'views/OrdersOverviewView/menu'

export default trackRoute => {
  return (
    <Route path='conversions' title='Conversions'>
      <Route
        path='conversion-count'
        metric='order_count'
        title='Conversion Count'
        components={{main: OrdersOverviewView, menu: OrdersOverviewViewMenu}}
        onEnter={trackRoute('conversion-count')}
        disableDatePicker
      />
      <Route
        path='conversion-amount'
        metric='order_amount'
        title='Revenue'
        components={{main: OrdersOverviewView, menu: OrdersOverviewViewMenu}}
        onEnter={trackRoute('conversion-value')}
        disableDatePicker
      />
      <IndexRedirect to='/conversions/conversion-count' />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/orders.js